export const CARD_BORDERRADIUS = '20px';
